import { Eye, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

/** Beside vendor identity: whether the host's package page names this vendor. `shown` comes from the
 * server (the vendor anonymity setting, read at request time); absent means hidden, the strict default. */
export function BlindBadge({ className, shown = false }: { className?: string; shown?: boolean }) {
  const Icon = shown ? Eye : Lock;
  return (
    <span
      className={cn("text-muted-foreground inline-flex items-center gap-1 text-xs", className)}
      title={
        shown
          ? "Vendor anonymity is off in Configuration: the host's package page names this vendor"
          : "The host's package page does not name this vendor; the booking email shares it at Booked"
      }
      data-tour="blind-badge"
    >
      <Icon aria-hidden className="size-3" />
      {shown ? "Visible to host" : "Hidden from host"}
    </span>
  );
}
